import { Box, TextField, Typography } from '@dtx-company/design-system/src'

type PlanPurchaseExperienceOrgNameInputProps = {
  label: string
  heading: string
  errorText?: string
  value: string
  onValueChange: (value: string) => void
}

export const PlanPurchaseExperienceOrgNameInput = ({
  label,
  heading,
  errorText,
  value,
  onValueChange
}: PlanPurchaseExperienceOrgNameInputProps): JSX.Element => {
  return (
    <>
      <Typography variant="subtitleSmall" mt="24px">
        {heading}
      </Typography>
      <Box
        sx={{
          label: {
            whiteSpace: 'wrap'
          }
        }}
      >
        <TextField
          type="text"
          fullWidth
          value={value}
          error={Boolean(errorText)}
          helperText={errorText}
          label={label}
          labelAbove={true}
          name="businessName"
          onChange={e => {
            onValueChange(e.target.value)
          }}
        />
      </Box>
    </>
  )
}
